export enum ThemeSettingPropertyType {
    BackgroundColor = 'BackgroundColor',
    BorderColor = 'BorderColor',
    TextColor = 'TextColor'
}
